<template>
  <v-card max-width="500">
    <apexchart type="bar" width="100%" :options="chartOptions" :series="series"></apexchart>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "BarChart",
  props: ['labels', 'values', 'horizontal', 'selected'],
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    series: [{
      name: '2021',
      data: [],
    },
    ],
  }),
  computed: {
    chartOptions: function () {
      return {
        chart: {
          type: 'bar',
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.$emit('update:selected', this.labels[config['dataPointIndex']])
            }
          }
        },
        legend: {
          position: 'bottom',
          show: false,
        },
        theme: {
          monochrome: {
            enabled: true,
            color: '#7400b8',
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
            horizontal: false,
          }
        },
        xaxis: {
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              }
            }
          },
        },
        yaxis: {
          labels: {
            show: false
          },
        },
        responsive: [{
          breakpoint: 350,
          options: {
            chart: {
              width: '100%'
            },
            legend: {
              show: false,
            }
          }
        }],
        noData: {
          text: 'Descargando...'
        },
        grid: {
          show: false,
        },
      }
    }
  },
  created() {
    this.series = [
      {
        name: '2021',
        data: this.values
      }
    ]
    this.chartOptions.xaxis.categories = this.labels;
    if (this.horizontal) {
      this.chartOptions.plotOptions.bar.horizontal = this.horizontal;
      this.chartOptions.yaxis.categories = this.labels;
      this.chartOptions.yaxis.labels.show = true;
    } else {
      this.chartOptions.xaxis.categories = this.labels;
    }
  },
}
</script>

<style scoped>
</style>
